/**
 * @generated SignedSource<<8967380b5d40feca026af213ef6eeb7b>>
 * @relayHash 00d9bc2c26544821ee95a0b36d8d22db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01051cfb0e6aa93635bfb2359938285f1c3b610f30affa8c99a454faafd23521

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SearchCombinationType = "AND" | "OR" | "%future added value";
export type SearchConfluenceDocumentStatus = "ARCHIVED" | "CURRENT" | "DRAFT" | "%future added value";
export type SearchConfluenceRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchContainerStatus = "ARCHIVED" | "CURRENT" | "%future added value";
export type SearchIssueStatusCategory = "DONE" | "INDETERMINATE" | "NEW" | "OPEN" | "UNDEFINED" | "%future added value";
export type SearchLinkedEntityGranularity = "ALL_MATCHING_MESSAGES" | "DEFAULT" | "FULL_THREAD" | "%future added value";
export type SearchParticipantType = "CONTRIBUTOR" | "MENTIONS" | "PRESENCE" | "%future added value";
export type SearchProjectType = "business" | "customer_service" | "product_discovery" | "service_desk" | "software" | "%future added value";
export type SearchSortOrder = "ASC" | "DESC" | "%future added value";
export type SearchThirdPartyRangeField = "CREATED" | "LASTMODIFIED" | "%future added value";
export type SearchCommonFilter = {
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  participants?: SearchParticipants | null | undefined;
  range?: SearchCommonRangeFilter | null | undefined;
};
export type SearchParticipants = {
  combination: SearchCombinationType;
  items: ReadonlyArray<SearchParticipant>;
};
export type SearchParticipant = {
  combination: SearchCombinationType;
  type: SearchParticipantType;
  users: ReadonlyArray<string>;
};
export type SearchCommonRangeFilter = {
  created?: SearchCommonRangeFilterFields | null | undefined;
  lastModified?: SearchCommonRangeFilterFields | null | undefined;
};
export type SearchCommonRangeFilterFields = {
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchConfluenceFilter = {
  ancestorIdsFilter?: ReadonlyArray<string> | null | undefined;
  containerARIs?: ReadonlyArray<string> | null | undefined;
  containerStatus?: ReadonlyArray<SearchContainerStatus | null | undefined> | null | undefined;
  contentStatuses?: ReadonlyArray<SearchConfluenceDocumentStatus> | null | undefined;
  contributorsFilter?: ReadonlyArray<string> | null | undefined;
  creatorsFilter?: ReadonlyArray<string> | null | undefined;
  isVerified?: boolean | null | undefined;
  labelsFilter?: ReadonlyArray<string> | null | undefined;
  mentions?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
  pageStatus?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchConfluenceRangeFilter | null | undefined> | null | undefined;
  spacesFilter?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchConfluenceRangeFilter = {
  field: SearchConfluenceRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchJiraFilter = {
  boardFilter?: SearchBoardFilter | null | undefined;
  issueFilter?: SearchJiraIssueFilter | null | undefined;
  projectFilter?: SearchJiraProjectFilter | null | undefined;
};
export type SearchBoardFilter = {
  negateProjectFilter?: boolean | null | undefined;
  projectARI?: string | null | undefined;
  userARI?: string | null | undefined;
};
export type SearchJiraIssueFilter = {
  assigneeARIs?: ReadonlyArray<string> | null | undefined;
  commenterARIs?: ReadonlyArray<string> | null | undefined;
  issueLabels?: ReadonlyArray<string> | null | undefined;
  issueTypeIDs?: ReadonlyArray<string> | null | undefined;
  issueTypes?: ReadonlyArray<string> | null | undefined;
  projectARIs?: ReadonlyArray<string> | null | undefined;
  reporterARIs?: ReadonlyArray<string> | null | undefined;
  statusCategories?: ReadonlyArray<SearchIssueStatusCategory> | null | undefined;
  watcherARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchJiraProjectFilter = {
  projectType?: SearchProjectType | null | undefined;
  projectTypes?: ReadonlyArray<SearchProjectType> | null | undefined;
};
export type SearchAssetsFilter = {
  objectSchemaFilter?: SearchAssetsObjectSchemaFilter | null | undefined;
  objectTypeFilter?: SearchAssetsObjectTypeFilter | null | undefined;
};
export type SearchAssetsObjectSchemaFilter = {
  schemaARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchAssetsObjectTypeFilter = {
  typeARIs?: ReadonlyArray<string> | null | undefined;
};
export type SearchMercuryFilter = {
  ancestorIds?: ReadonlyArray<string> | null | undefined;
  focusAreaTypeIds?: ReadonlyArray<string> | null | undefined;
  owners?: ReadonlyArray<string> | null | undefined;
};
export type SearchCompassFilter = {
  componentFilter?: SearchCompassComponentFilter | null | undefined;
};
export type SearchCompassComponentFilter = {
  componentStates: ReadonlyArray<string>;
};
export type SearchThirdPartyFilter = {
  additionalTexts?: ReadonlyArray<string> | null | undefined;
  ancestorAris?: ReadonlyArray<string> | null | undefined;
  assignees?: ReadonlyArray<string> | null | undefined;
  containerAris?: ReadonlyArray<string> | null | undefined;
  containerNames?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  createdBy?: ReadonlyArray<string> | null | undefined;
  excludeSubtypes?: ReadonlyArray<string> | null | undefined;
  integrations?: ReadonlyArray<string> | null | undefined;
  labels?: ReadonlyArray<string> | null | undefined;
  lastUpdatedBy?: ReadonlyArray<string> | null | undefined;
  range?: ReadonlyArray<SearchThirdPartyRangeFilter | null | undefined> | null | undefined;
  subtypes?: ReadonlyArray<string | null | undefined> | null | undefined;
  thirdPartyProducts?: ReadonlyArray<SearchThirdPartyProduct> | null | undefined;
  thirdPartyTypes?: ReadonlyArray<string> | null | undefined;
  titleMatchOnly?: boolean | null | undefined;
};
export type SearchThirdPartyRangeFilter = {
  field: SearchThirdPartyRangeField;
  gt?: string | null | undefined;
  lt?: string | null | undefined;
};
export type SearchThirdPartyProduct = {
  connectorSources?: ReadonlyArray<string> | null | undefined;
  containerTypes?: ReadonlyArray<string> | null | undefined;
  datasourceId?: string | null | undefined;
  entities?: ReadonlyArray<string> | null | undefined;
  integrationId?: string | null | undefined;
  linkedEntityGranularity?: SearchLinkedEntityGranularity | null | undefined;
  product?: string | null | undefined;
  providerId?: string | null | undefined;
  subtypes?: ReadonlyArray<string> | null | undefined;
};
export type SearchSortInput = {
  field: string;
  key?: string | null | undefined;
  order: SearchSortOrder;
};
export type SearchExperimentLayer = {
  definitions?: ReadonlyArray<SearchLayerDefinition | null | undefined> | null | undefined;
  layerId?: string | null | undefined;
  name?: string | null | undefined;
  shadowId?: string | null | undefined;
};
export type SearchLayerDefinition = {
  abTestId?: string | null | undefined;
  connectorSources?: ReadonlyArray<string | null | undefined> | null | undefined;
  entity?: string | null | undefined;
  integrationARI?: string | null | undefined;
  layerId?: string | null | undefined;
  providerId?: string | null | undefined;
  shadowId?: string | null | undefined;
  subEntity?: string | null | undefined;
};
export type rightPanelQuery$variables = {
  assetsFilters?: SearchAssetsFilter | null | undefined;
  cloudIdARI: string;
  commonFilters?: SearchCommonFilter | null | undefined;
  compassFilters?: SearchCompassFilter | null | undefined;
  confluenceFilters?: SearchConfluenceFilter | null | undefined;
  disableQueryReplacement?: boolean | null | undefined;
  entities: ReadonlyArray<string>;
  experience: string;
  experimentId?: string | null | undefined;
  experimentLayers?: ReadonlyArray<SearchExperimentLayer | null | undefined> | null | undefined;
  jiraFilters?: SearchJiraFilter | null | undefined;
  limit: number;
  mercuryFilters?: SearchMercuryFilter | null | undefined;
  query: string;
  queryVersion?: number | null | undefined;
  searchSessionId?: string | null | undefined;
  sessionId?: string | null | undefined;
  shadowExperimentId?: string | null | undefined;
  sort?: ReadonlyArray<SearchSortInput | null | undefined> | null | undefined;
  sourceProduct?: string | null | undefined;
  thirdPartyFilters?: SearchThirdPartyFilter | null | undefined;
};
export type rightPanelQuery$data = {
  readonly search: {
    readonly results: {
      readonly totalCounts: ReadonlyArray<{
        readonly count: number;
        readonly product: string;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type rightPanelQuery = {
  response: rightPanelQuery$data;
  variables: rightPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetsFilters"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdARI"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commonFilters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "compassFilters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confluenceFilters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableQueryReplacement"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entities"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experience"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "experimentLayers"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraFilters"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mercuryFilters"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryVersion"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchSessionId"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shadowExperimentId"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceProduct"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "thirdPartyFilters"
},
v21 = [
  {
    "concreteType": "SearchQueryAPI",
    "kind": "LinkedField",
    "name": "search",
    "plural": false,
    "selections": [
      {
        "alias": "results",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "queryVersion",
                "variableName": "queryVersion"
              },
              {
                "kind": "Variable",
                "name": "searchSessionId",
                "variableName": "searchSessionId"
              },
              {
                "kind": "Variable",
                "name": "sessionId",
                "variableName": "sessionId"
              },
              {
                "kind": "Variable",
                "name": "sourceProduct",
                "variableName": "sourceProduct"
              }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
          },
          {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
          },
          {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "experimentId",
                "variableName": "experimentId"
              },
              {
                "kind": "Variable",
                "name": "experimentLayers",
                "variableName": "experimentLayers"
              },
              {
                "kind": "Variable",
                "name": "shadowExperimentId",
                "variableName": "shadowExperimentId"
              }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
          },
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "assetsFilters",
                "variableName": "assetsFilters"
              },
              {
                "kind": "Variable",
                "name": "commonFilters",
                "variableName": "commonFilters"
              },
              {
                "kind": "Variable",
                "name": "compassFilters",
                "variableName": "compassFilters"
              },
              {
                "kind": "Variable",
                "name": "confluenceFilters",
                "variableName": "confluenceFilters"
              },
              {
                "kind": "Variable",
                "name": "entities",
                "variableName": "entities"
              },
              {
                "kind": "Variable",
                "name": "jiraFilters",
                "variableName": "jiraFilters"
              },
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "locations.0",
                    "variableName": "cloudIdARI"
                  }
                ],
                "kind": "ListValue",
                "name": "locations"
              },
              {
                "kind": "Variable",
                "name": "mercuryFilters",
                "variableName": "mercuryFilters"
              },
              {
                "kind": "Variable",
                "name": "thirdPartyFilters",
                "variableName": "thirdPartyFilters"
              }
            ],
            "kind": "ObjectValue",
            "name": "filters"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          }
        ],
        "concreteType": "SearchItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "concreteType": "SearchProductCount",
            "kind": "LinkedField",
            "name": "totalCounts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "product"
              },
              {
                "kind": "ScalarField",
                "name": "count"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ],
    "kind": "Fragment",
    "name": "rightPanelQuery",
    "selections": (v21/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v13/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      (v6/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v3/*: any*/),
      (v20/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v8/*: any*/),
      (v17/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "rightPanelQuery",
    "selections": (v21/*: any*/)
  },
  "params": {
    "id": "01051cfb0e6aa93635bfb2359938285f1c3b610f30affa8c99a454faafd23521",
    "metadata": {},
    "name": "rightPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d7e9c06a7c742846f086b3d81486be0";

export default node;
